import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './cloud-security-assessment.css'

const CloudSecurityAssessment = (props) => {
  return (
    <div className="cloud-security-assessment-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Cloud-Security-Assessment - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/cloud-security-assessment"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-wrapper">
          <img
            alt="A cybersecurity expert inspecting lines of code on multiple monitors in a dimly lit office."
            src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-image cloud-security-assessment-hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="cloud-security-assessment-hero-content-wrapper">
          <div className="cloud-security-assessment-hero-content hero-content">
            <div className="cloud-security-assessment-hero-icon-wrapper">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
                className="cloud-security-assessment-hero-icon"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h1 className="hero-title cloud-security-assessment-hero-title">
              Cloud Security Assessment
            </h1>
            <p className="cloud-security-assessment-hero-subtitle hero-subtitle">
              Comprehensive cloud risk assessment, CSPM analysis, and IAM review
              to reduce vulnerabilities by up to 85%, ensure compliance
              alignment with ISO, SOC2, and NIST standards, and deliver
              measurable security improvements across your entire cloud
              infrastructure.
            </p>
            <div className="cloud-security-assessment-hero-cta-group hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#services">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Services</span>
                </div>
              </a>
            </div>
            <div className="cloud-security-assessment-hero-stats">
              <div className="hero-stat-item">
                <div className="hero-stat-value">
                  <span>85%</span>
                </div>
                <div className="cloud-security-assessment-hero-stat-label">
                  <span>Risk Reduction</span>
                </div>
              </div>
              <div className="hero-stat-item">
                <div className="hero-stat-value">
                  <span>100%</span>
                </div>
                <div className="cloud-security-assessment-hero-stat-label">
                  <span>Compliance Coverage</span>
                </div>
              </div>
              <div className="hero-stat-item">
                <div className="hero-stat-value">
                  <span>24/7</span>
                </div>
                <div className="cloud-security-assessment-hero-stat-label">
                  <span>Monitoring</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="overview-section">
        <div className="overview-container">
          <div className="overview-header">
            <h2 className="section-title">
              Comprehensive Cloud Security Coverage
            </h2>
            <p className="section-subtitle">
              Our cloud security assessment delivers deep visibility across your
              entire infrastructure with automated and manual testing, advanced
              CSPM analysis, and real-time risk prioritization.
            </p>
          </div>
          <div className="overview-grid">
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="overview-card-title">Cloud Risk Assessment</h3>
              <p className="overview-card-description">
                Identify and quantify risks across AWS, Azure, GCP, and hybrid
                cloud environments with automated scanning and expert analysis
                of security posture and threat exposure.
              </p>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242M16 17H7m10 4H9"></path>
                  </g>
                </svg>
              </div>
              <h3 className="overview-card-title">CSPM Analysis</h3>
              <p className="overview-card-description">
                Cloud Security Posture Management with continuous monitoring,
                configuration drift detection, and real-time alerts for
                misconfigurations, policy violations, and compliance gaps.
              </p>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="overview-card-title">IAM Review</h3>
              <p className="overview-card-description">
                Deep dive into identity and access management policies,
                privilege escalation paths, orphaned accounts, excessive
                permissions, and role-based access control weaknesses.
              </p>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="overview-card-title">
                Misconfiguration Detection
              </h3>
              <p className="overview-card-description">
                Automated scanning for common and critical misconfigurations
                including exposed storage, open ports, weak encryption, insecure
                APIs, and vulnerable network configurations.
              </p>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="overview-card-title">Compliance Checks</h3>
              <p className="overview-card-description">
                Validate alignment with ISO 27001, SOC 2, PCI-DSS, HIPAA, NIST,
                and CIS benchmarks through automated compliance scanning and
                manual verification of critical controls.
              </p>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="overview-card-title">Risk Prioritization</h3>
              <p className="overview-card-description">
                Intelligent risk scoring and prioritization based on
                exploitability, business impact, data sensitivity, and
                regulatory requirements to focus remediation on critical issues
                first.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="cspm-iam-section">
        <div className="cspm-iam-container">
          <div className="cspm-iam-header">
            <h2 className="section-title">
              CSPM Findings &amp; IAM Access Review
            </h2>
            <p className="section-subtitle">
              Detailed analysis of cloud security posture with automated CSPM
              findings, IAM privilege analysis, and risk-based prioritization to
              guide remediation efforts effectively.
            </p>
          </div>
          <div className="cspm-iam-table-wrapper">
            <table className="cspm-iam-table">
              <thead className="cspm-iam-thead">
                <tr>
                  <th className="cspm-iam-th">
                    <span>Finding Category</span>
                  </th>
                  <th className="cspm-iam-th">
                    <span>Risk Level</span>
                  </th>
                  <th className="cspm-iam-th">
                    <span>Affected Resources</span>
                  </th>
                  <th className="cspm-iam-th">
                    <span>Impact</span>
                  </th>
                  <th className="cspm-iam-th">
                    <span>Priority</span>
                  </th>
                </tr>
              </thead>
              <tbody className="cspm-iam-tbody">
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                            width="18"
                            height="11"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </g>
                      </svg>
                      <span>IAM Excessive Permissions</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-critical">
                      Critical
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>47 Users, 12 Roles</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Privilege escalation, data exfiltration risk</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-high cspm-iam-priority">
                      P0
                    </span>
                  </td>
                </tr>
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <path
                          d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Public S3 Buckets</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-critical">
                      Critical
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>8 Buckets</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Data breach, unauthorized access</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-high cspm-iam-priority">
                      P0
                    </span>
                  </td>
                </tr>
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <path
                          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Unencrypted Data at Rest</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-high">
                      High
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>23 Volumes, 15 Databases</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Compliance violation, data exposure</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-high cspm-iam-priority">
                      P1
                    </span>
                  </td>
                </tr>
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <path
                          d="M12 12v4m0 4h.01M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>MFA Not Enforced</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-high">
                      High
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>34 Admin Accounts</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Account takeover, unauthorized access</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-high cspm-iam-priority">
                      P1
                    </span>
                  </td>
                </tr>
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="10" cx="12" cy="12"></circle>
                          <path d="M12 8v4m0 4h.01"></path>
                        </g>
                      </svg>
                      <span>Logging &amp; Monitoring Gaps</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>19 Services</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Reduced incident detection capability</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-medium cspm-iam-priority">
                      P2
                    </span>
                  </td>
                </tr>
                <tr className="cspm-iam-tr">
                  <td className="cspm-iam-td">
                    <div className="cspm-iam-category">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="cspm-iam-icon"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                            width="18"
                            height="11"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                        </g>
                      </svg>
                      <span>Orphaned Access Keys</span>
                    </div>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-badge cspm-iam-badge-medium">
                      Medium
                    </span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>28 Keys</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span>Potential unauthorized access vector</span>
                  </td>
                  <td className="cspm-iam-td">
                    <span className="cspm-iam-priority-medium cspm-iam-priority">
                      P2
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="configuration-section">
        <div className="configuration-container">
          <div className="configuration-header">
            <h2 className="section-title">
              Automated &amp; Manual Configuration Checks
            </h2>
            <p className="section-subtitle">
              Comprehensive validation across cloud infrastructure with
              automated policy enforcement and expert manual verification to
              ensure compliance with ISO 27001, SOC 2, PCI-DSS, NIST, and CIS
              benchmarks.
            </p>
          </div>
          <div className="configuration-grid">
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="configuration-card-title">Network Security</h3>
              <p className="configuration-card-description">
                Security group rules, network ACLs, VPC configurations, firewall
                policies, open ports scanning, and ingress/egress traffic
                validation against best practices.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">156</span>
                  <span className="configuration-metric-label">
                    Rules Checked
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">94%</span>
                  <span className="configuration-metric-label">Pass Rate</span>
                </div>
              </div>
            </div>
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="configuration-card-title">Data Encryption</h3>
              <p className="configuration-card-description">
                Encryption at rest and in transit validation, KMS key rotation
                policies, SSL/TLS certificate verification, and database
                encryption compliance checks.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">89</span>
                  <span className="configuration-metric-label">
                    Resources Scanned
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">78%</span>
                  <span className="configuration-metric-label">Compliance</span>
                </div>
              </div>
            </div>
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="configuration-card-title">Access Logging</h3>
              <p className="configuration-card-description">
                CloudTrail configuration, S3 access logging, VPC flow logs,
                database audit logs, API gateway logging, and centralized log
                aggregation validation.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">42</span>
                  <span className="configuration-metric-label">
                    Services Reviewed
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">86%</span>
                  <span className="configuration-metric-label">Coverage</span>
                </div>
              </div>
            </div>
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="configuration-card-title">
                Backup &amp; Recovery
              </h3>
              <p className="configuration-card-description">
                Automated backup policies, snapshot configurations, disaster
                recovery procedures, backup encryption, retention policies, and
                recovery time objectives validation.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">67</span>
                  <span className="configuration-metric-label">
                    Systems Audited
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">92%</span>
                  <span className="configuration-metric-label">
                    Backup Coverage
                  </span>
                </div>
              </div>
            </div>
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="configuration-card-title">Compliance Controls</h3>
              <p className="configuration-card-description">
                ISO 27001, SOC 2, PCI-DSS, HIPAA, NIST CSF, and CIS Benchmark
                controls validation through automated scanning and manual expert
                verification processes.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">234</span>
                  <span className="configuration-metric-label">
                    Controls Tested
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">88%</span>
                  <span className="configuration-metric-label">
                    Compliance Score
                  </span>
                </div>
              </div>
            </div>
            <div className="configuration-card">
              <div className="configuration-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="configuration-card-title">Patch Management</h3>
              <p className="configuration-card-description">
                Operating system patches, security updates, vulnerability
                remediation, patch deployment schedules, and automated update
                verification across all instances.
              </p>
              <div className="configuration-card-metrics">
                <div className="configuration-metric">
                  <span className="configuration-metric-value">128</span>
                  <span className="configuration-metric-label">
                    Instances Scanned
                  </span>
                </div>
                <div className="configuration-metric">
                  <span className="configuration-metric-value">76%</span>
                  <span className="configuration-metric-label">Up-to-date</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cloud-security-assessment-timeline-section">
        <div className="timeline-wrapper">
          <div className="cloud-security-assessment-timeline-header">
            <h2 className="section-title">
              Remediation Roadmap with Clear Accountability
            </h2>
            <p className="section-subtitle">
              Structured remediation plan with prioritized milestones, assigned
              ownership, and measurable success criteria to systematically
              eliminate security risks and achieve compliance objectives.
            </p>
          </div>
          <div className="timeline-container">
            <div className="cloud-security-assessment-timeline-item">
              <div className="timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="timeline-content">
                <div className="timeline-phase">
                  <span>Phase 1</span>
                </div>
                <h3 className="timeline-title">Critical Risk Remediation</h3>
                <p className="timeline-description">
                  Address P0 critical vulnerabilities including IAM excessive
                  permissions, public S3 buckets, and unencrypted data at rest.
                  Immediate action required to prevent data breaches and
                  unauthorized access.
                </p>
                <div className="timeline-details">
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Timeline</span>
                    <span className="timeline-detail-value">Week 1-2</span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Owner</span>
                    <span className="timeline-detail-value">
                      Cloud Security Team
                    </span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">
                      Success Metric
                    </span>
                    <span className="timeline-detail-value">
                      100% P0 Issues Resolved
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cloud-security-assessment-timeline-item">
              <div className="timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="timeline-content">
                <div className="timeline-phase">
                  <span>Phase 2</span>
                </div>
                <h3 className="timeline-title">
                  High Priority Security Controls
                </h3>
                <p className="timeline-description">
                  Implement MFA enforcement, enable comprehensive logging and
                  monitoring, remediate network security gaps, and establish
                  automated backup procedures across all critical systems.
                </p>
                <div className="timeline-details">
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Timeline</span>
                    <span className="timeline-detail-value">Week 3-5</span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Owner</span>
                    <span className="timeline-detail-value">
                      Infrastructure &amp; IAM Teams
                    </span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">
                      Success Metric
                    </span>
                    <span className="timeline-detail-value">
                      95% P1 Issues Resolved
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cloud-security-assessment-timeline-item">
              <div className="timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                    <path d="m9 9.5l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-content">
                <div className="timeline-phase">
                  <span>Phase 3</span>
                </div>
                <h3 className="timeline-title">Compliance Alignment</h3>
                <p className="timeline-description">
                  Achieve full compliance with ISO 27001, SOC 2, and NIST
                  frameworks. Document all security controls, establish audit
                  trails, and implement continuous compliance monitoring
                  systems.
                </p>
                <div className="timeline-details">
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Timeline</span>
                    <span className="timeline-detail-value">Week 6-8</span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Owner</span>
                    <span className="timeline-detail-value">
                      Compliance &amp; Audit Teams
                    </span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">
                      Success Metric
                    </span>
                    <span className="timeline-detail-value">
                      100% Compliance Attestation
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cloud-security-assessment-timeline-item">
              <div className="timeline-marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="timeline-content">
                <div className="timeline-phase">
                  <span>Phase 4</span>
                </div>
                <h3 className="timeline-title">
                  Continuous Monitoring &amp; Optimization
                </h3>
                <p className="timeline-description">
                  Deploy automated CSPM tools, establish security operations
                  procedures, implement periodic security assessments, and
                  create continuous improvement processes for sustained security
                  posture.
                </p>
                <div className="timeline-details">
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Timeline</span>
                    <span className="timeline-detail-value">Week 9-12</span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">Owner</span>
                    <span className="timeline-detail-value">
                      SecOps &amp; DevSecOps Teams
                    </span>
                  </div>
                  <div className="timeline-detail-item">
                    <span className="timeline-detail-label">
                      Success Metric
                    </span>
                    <span className="timeline-detail-value">
                      24/7 Monitoring Active
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="reports-section">
        <div className="reports-container">
          <div className="reports-header">
            <h2 className="section-title">
              Comprehensive Reporting Tailored for Every Stakeholder
            </h2>
            <p className="section-subtitle">
              Executive summaries for decision-makers, technical findings for
              security teams, and actionable remediation guidance for
              engineering teams—all delivered in a unified, accessible format.
            </p>
          </div>
          <div className="reports-tabs">
            <div className="reports-tab-list">
              <button
                id="reports-tab-executive"
                className="reports-tab-button reports-tab-active"
              >
                Executive Summary
              </button>
              <button id="reports-tab-technical" className="reports-tab-button">
                Technical Findings
              </button>
              <button
                id="reports-tab-remediation"
                className="reports-tab-button"
              >
                Remediation Guide
              </button>
            </div>
            <div className="reports-tab-content">
              <div
                id="reports-panel-executive"
                className="reports-tab-panel reports-tab-panel-active"
              >
                <div className="reports-panel-content">
                  <div className="reports-panel-icon">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <h3 className="reports-panel-title">
                    Executive Risk Overview
                  </h3>
                  <p className="reports-panel-description">
                    High-level security posture assessment with business risk
                    quantification, compliance status, strategic
                    recommendations, and ROI analysis for security investments.
                    Designed for C-suite and board presentations.
                  </p>
                  <div className="reports-panel-features">
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Risk heat map with business impact</span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Compliance dashboard for key frameworks</span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Strategic security roadmap with timelines</span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Budget and resource allocation guidance</span>
                    </div>
                  </div>
                </div>
              </div>
              <div id="reports-panel-technical" className="reports-tab-panel">
                <div className="reports-panel-content">
                  <div className="reports-panel-icon">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <h3 className="reports-panel-title">
                    Detailed Security Analysis
                  </h3>
                  <p className="reports-panel-description">
                    Comprehensive technical findings with vulnerability details,
                    exploit scenarios, configuration analysis, and deep-dive
                    security architecture review. Built for security engineers
                    and architects.
                  </p>
                  <div className="reports-panel-features">
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Detailed vulnerability enumeration with CVSS scores
                      </span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Attack path analysis and privilege escalation scenarios
                      </span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Configuration drift analysis and baseline comparisons
                      </span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Security architecture recommendations and best practices
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div id="reports-panel-remediation" className="reports-tab-panel">
                <div className="reports-panel-content">
                  <div className="reports-panel-icon">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle r="10" cx="12" cy="12"></circle>
                        <circle r="6" cx="12" cy="12"></circle>
                        <circle r="2" cx="12" cy="12"></circle>
                      </g>
                    </svg>
                  </div>
                  <h3 className="reports-panel-title">
                    Actionable Remediation Steps
                  </h3>
                  <p className="reports-panel-description">
                    Step-by-step remediation instructions with code samples,
                    configuration templates, automation scripts, and validation
                    procedures. Enables rapid, accurate implementation by DevOps
                    and engineering teams.
                  </p>
                  <div className="reports-panel-features">
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Step-by-step remediation procedures with screenshots
                      </span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        IaC templates and automation scripts (Terraform,
                        CloudFormation)
                      </span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>Verification and validation test procedures</span>
                    </div>
                    <div className="reports-feature-item">
                      <svg
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        className="reports-feature-icon"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <span>
                        Rollback procedures and change management guidance
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="standards-section">
        <div className="standards-container">
          <div className="standards-header">
            <h2 className="section-title">
              Comprehensive Standards Mapping &amp; Traceability
            </h2>
            <p className="section-subtitle">
              Every finding is mapped to specific controls across ISO 27001, SOC
              2, PCI-DSS, NIST CSF, and CIS Benchmarks, providing complete audit
              traceability and compliance documentation.
            </p>
          </div>
          <div className="standards-table-wrapper">
            <table className="standards-table">
              <thead className="standards-thead">
                <tr>
                  <th className="standards-th">
                    <span>Finding Category</span>
                  </th>
                  <th className="standards-th">
                    <span>ISO 27001</span>
                  </th>
                  <th className="standards-th">
                    <span>SOC 2</span>
                  </th>
                  <th className="standards-th">
                    <span>PCI-DSS</span>
                  </th>
                  <th className="standards-th">
                    <span>NIST CSF</span>
                  </th>
                  <th className="standards-th">
                    <span>CIS Controls</span>
                  </th>
                </tr>
              </thead>
              <tbody className="standards-tbody">
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>IAM Excessive Permissions</span>
                  </td>
                  <td className="standards-td">
                    <span>A.9.2.3, A.9.4.1</span>
                  </td>
                  <td className="standards-td">
                    <span>CC6.1, CC6.2</span>
                  </td>
                  <td className="standards-td">
                    <span>7.1, 7.2, 8.1</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.AC-4, PR.DS-5</span>
                  </td>
                  <td className="standards-td">
                    <span>5.1, 5.4, 6.8</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Public S3 Buckets</span>
                  </td>
                  <td className="standards-td">
                    <span>A.8.2.3, A.13.1.3</span>
                  </td>
                  <td className="standards-td">
                    <span>CC6.6, CC6.7</span>
                  </td>
                  <td className="standards-td">
                    <span>1.3, 2.2</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.AC-3, PR.DS-1</span>
                  </td>
                  <td className="standards-td">
                    <span>13.1, 14.6</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Unencrypted Data at Rest</span>
                  </td>
                  <td className="standards-td">
                    <span>A.10.1.1, A.10.1.2</span>
                  </td>
                  <td className="standards-td">
                    <span>CC6.1, CC6.6</span>
                  </td>
                  <td className="standards-td">
                    <span>3.4, 3.5, 3.6</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.DS-1, PR.DS-2</span>
                  </td>
                  <td className="standards-td">
                    <span>3.11, 13.1</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>MFA Not Enforced</span>
                  </td>
                  <td className="standards-td">
                    <span>A.9.4.2, A.9.4.3</span>
                  </td>
                  <td className="standards-td">
                    <span>CC6.1, CC6.2</span>
                  </td>
                  <td className="standards-td">
                    <span>8.3, 8.6</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.AC-1, PR.AC-7</span>
                  </td>
                  <td className="standards-td">
                    <span>4.5, 6.3, 6.5</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Logging &amp; Monitoring Gaps</span>
                  </td>
                  <td className="standards-td">
                    <span>A.12.4.1, A.12.4.3</span>
                  </td>
                  <td className="standards-td">
                    <span>CC7.2, CC7.3</span>
                  </td>
                  <td className="standards-td">
                    <span>10.2, 10.3</span>
                  </td>
                  <td className="standards-td">
                    <span>DE.AE-3, DE.CM-1</span>
                  </td>
                  <td className="standards-td">
                    <span>8.2, 8.5, 8.11</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Network Security Groups</span>
                  </td>
                  <td className="standards-td">
                    <span>A.13.1.1, A.13.1.3</span>
                  </td>
                  <td className="standards-td">
                    <span>CC6.6, CC6.7</span>
                  </td>
                  <td className="standards-td">
                    <span>1.1, 1.2, 1.3</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.AC-5, PR.PT-4</span>
                  </td>
                  <td className="standards-td">
                    <span>12.2, 13.1</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Backup &amp; Recovery</span>
                  </td>
                  <td className="standards-td">
                    <span>A.12.3.1, A.17.1.2</span>
                  </td>
                  <td className="standards-td">
                    <span>CC9.1, A1.2</span>
                  </td>
                  <td className="standards-td">
                    <span>3.4, 12.10</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.IP-4, RC.RP-1</span>
                  </td>
                  <td className="standards-td">
                    <span>11.1, 11.2, 11.3</span>
                  </td>
                </tr>
                <tr className="standards-tr">
                  <td className="standards-td standards-td-category">
                    <span>Patch Management</span>
                  </td>
                  <td className="standards-td">
                    <span>A.12.6.1, A.14.2.2</span>
                  </td>
                  <td className="standards-td">
                    <span>CC7.1, CC8.1</span>
                  </td>
                  <td className="standards-td">
                    <span>6.2, 11.2</span>
                  </td>
                  <td className="standards-td">
                    <span>PR.IP-12, DE.CM-8</span>
                  </td>
                  <td className="standards-td">
                    <span>7.1, 7.2, 7.3</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="cloud-security-assessment-cta-section cta-section">
        <div className="cta-container">
          <div className="cloud-security-assessment-cta-content-wrapper">
            <div className="cloud-security-assessment-cta-content-left">
              <h2 className="section-title">
                Ready to Secure Your Cloud Infrastructure?
              </h2>
              <p className="section-content">
                Partner with Cysigil to identify vulnerabilities, achieve
                compliance, and build a resilient cloud security posture. Our
                expert team is ready to deliver a comprehensive assessment
                tailored to your unique environment.
              </p>
              <div className="cta-features-list">
                <div className="cloud-security-assessment-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    className="cta-feature-icon"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>
                    Comprehensive cloud risk assessment across all environments
                  </span>
                </div>
                <div className="cloud-security-assessment-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    className="cta-feature-icon"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>
                    Expert guidance from certified cloud security professionals
                  </span>
                </div>
                <div className="cloud-security-assessment-cta-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    className="cta-feature-icon"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>
                    Actionable remediation plans with clear ownership and
                    timelines
                  </span>
                </div>
              </div>
            </div>
            <div className="cloud-security-assessment-cta-content-right">
              <div className="cloud-security-assessment-cta-card">
                <h3 className="cloud-security-assessment-cta-card-title">
                  Get Started Today
                </h3>
                <p className="cta-card-description">
                  Download our comprehensive assessment methodology guide to
                  understand our approach and deliverables.
                </p>
                <a href="#contact">
                  <div className="btn-primary btn btn-lg">
                    <span>Request Assessment</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cloud-security-assessment-container2">
        <div className="cloud-security-assessment-container3">
          <Script
            html={`<script defer data-name="reports-tabs">
(function(){
  const reportsTabs = document.querySelectorAll(".reports-tab-button")
  const reportsPanels = document.querySelectorAll(".reports-tab-panel")

  reportsTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      reportsTabs.forEach((t) => t.classList.remove("reports-tab-active"))
      reportsPanels.forEach((p) => p.classList.remove("reports-tab-panel-active"))

      tab.classList.add("reports-tab-active")
      reportsPanels[index].classList.add("reports-tab-panel-active")
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default CloudSecurityAssessment
